import { useMediaQuery } from 'usehooks-ts';

import { useAccount } from 'shared/hooks/use-web3';

// Use web3 instead of wagmi

import { usePrizeBoxController } from './use-prize-box-controller';

export function usePrizeBoxPage() {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const { isConnected, address } = useAccount();
  const controller = usePrizeBoxController();

  return {
    isMobile,
    isConnected,
    address,
    ...controller,
  };
}
